import { Col, Form, Input, Row } from "antd";

import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BalanceContext from "../../context/BalanceContext";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaSelect from "../Items/Select/Index";
import ColoredSelect from "../Items/Select/ColoredSelect";
import { priorityColors } from "../../helpers/tickets";
import PlusIcon from "./../../assets/svgs/IconsWhite/PlusIcon.svg";
import "./support-tickets.css";
const priorityOptions = [
  { label: "Low", value: "LOW" },
  { label: "Medium", value: "MEDIUM" },
  { label: "High", value: "HIGH" },
  { label: "Critical", value: "CRITICAL" },
];
const issues = [
  { label: "No Internet", value: "No Internet" },
  { label: "Slow Internet", value: "Slow Internet" },
  {
    label: "Internet keeps disconnecting",
    value: "Internet keeps disconnecting",
  },
  { label: "Wi-Fi issue", value: "Wi-Fi issue" },
  { label: "Router not turning on", value: "Router not turning on" },
  {
    label: "Router lights blinking / showing red",
    value: "Router lights blinking / showing red",
  },
  { label: "Weak signal", value: "Weak signal" },
  {
    label: "Buffering while watching videos",
    value: "Buffering while watching videos",
  },
  { label: "Online games lagging", value: "Online games lagging" },
  { label: "Websites not loading", value: "Websites not loading" },
  { label: "Package not activated", value: "Package not activated" },
  { label: "Cable issue", value: "Cable issue" },
  {
    label: "Speed lower than my package",
    value: "Speed lower than my package",
  },
  { label: "TV service not working", value: "TV service not working" },
  { label: "Other issue", value: "Other issue" },
];

// Color mapping for issue types
const typeColors: Record<string, string> = {
  "No Internet": "red",
  "Slow Internet": "orange",
  "Internet keeps disconnecting": "orange",
  "Wi-Fi issue": "blue",
  "Router not turning on": "red",
  "Router lights blinking / showing red": "red",
  "Weak signal": "orange",
  "Buffering while watching videos": "orange",
  "Online games lagging": "orange",
  "Websites not loading": "blue",
  "Package not activated": "purple",
  "Cable issue": "red",
  "Speed lower than my package": "orange",
  "TV service not working": "purple",
  "Other issue": "default",
};

const CreateNewTicketForm = () => {
  const [getConnectionsApi, connectionsApiResponse] =
    useAxiosPost<ResponseProp>(
      "connections/getConnectionsByCompanyMiniDetails"
    );
  const [connectionOptions, setConnectionsOptions] = useState<
    NetwalaSelectOptions[]
  >([]);
  const navigate = useNavigate();
  const { openNotification, contextHolder } = useMultiNotification();
  const [form] = Form.useForm();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<CreateNewTicketApiProp>(
    "support/tickets/createNewTicket",
    true
  );

  const onFinish = (values: any) => {
    console.log(values);
    const dataToSend: CreateNewTicketApiProp = {
      title: values.title,
      description: values.description,
      priority: values.priority,
      type: values.type,
      connectionId: values.connection,
    };
    postApiData(dataToSend);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log(errorInfo);
  };
  useEffect(() => {
    getConnectionsApi({});
  }, []);
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification(`success`, "Success", message);
        setTimeout(() => {
          navigate(-1);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification(`error`, "Operation Failed", apiError);
    }
  }, [apiError, apiErrorCount]);
  useEffect(() => {
    if (connectionsApiResponse !== null) {
      const data: any = connectionsApiResponse.responseData;
      const connectionOptions: NetwalaSelectOptions[] = [];
      data.map((item: any) => {
        if (item.connectionType === "INTERNET") {
          connectionOptions.push({
            label: item.username,
            value: item.intPkConnectionID,
          });
        } else if (item.connectionType === "CATV") {
          connectionOptions.push({
            label: `${item.firstName} ${item.lastName} - ${item.address}`,
            value: item.intPkConnectionID,
          });
        }
      });
      setConnectionsOptions(connectionOptions);
    }
  }, [connectionsApiResponse]);
  return (
    <>
      {contextHolder}

      <Row style={{ width: "100%" }}>
        <Form
          name="createTicketForm"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          requiredMark={false}
          style={{ width: "100%" }}
          form={form}
        >
          {/* First */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">Title</span>}
                name="title"
                getValueFromEvent={(e) => e.target.value.trimStart()} // trims start spaces as user types
                rules={[
                  {
                    required: true,
                    message: "Please enter Title",
                  },
                  {
                    pattern: /^[A-Za-z0-9 ]+$/,
                    message: "Only letters, numbers, and spaces are allowed",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.trim().length === 0) {
                        return Promise.reject("Title cannot be just spaces");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Title"
                  onBlur={(e) => {
                    e.target.value = e.target.value.trim(); // trim on blur
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">
                    Choose Connection
                  </span>
                }
                name="connection"
                rules={[
                  {
                    required: true,
                    message: "Please Choose Connection",
                  },
                ]}
              >
                <NetwalaSelect
                  size="large"
                  height="45px"
                  options={connectionOptions}
                  showSearch={true}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">Priority</span>}
                name="priority"
                rules={[
                  {
                    required: true,
                    message: "Please Select Priority",
                  },
                ]}
              >
                <ColoredSelect
                  showSearch
                  size="large"
                  height="45px"
                  options={priorityOptions}
                  colorMap={priorityColors}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">Type</span>}
                name="type"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter Sub Area",
                //   },
                // ]}
              >
                <ColoredSelect
                  showSearch
                  size="large"
                  height="45px"
                  options={issues}
                  colorMap={typeColors}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label={
                  <span className="create-user-form-label">Description</span>
                }
                name="description"
                rules={[
                  {
                    required: true,
                    message: "Please enter Description",
                  },
                ]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Your Description Here..."
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col
              style={{ display: "flex", justifyContent: "center" }}
              span={24}
            >
              <Form.Item>
                <NetwalaButton
                  htmlType="submit"
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={ButtonProps.width.STANDARD}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {
                    console.log("clicked");
                  }}
                  text={apiLoading ? "Creating..." : "Create Ticket"}
                  icon={<img src={PlusIcon} />}
                  disabled={apiLoading}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Row>
    </>
  );
};
export default CreateNewTicketForm;
